import Vue from 'vue'
import VueRouter from 'vue-router'

// import Sign from '../views/sign/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/projectlist'
  },
  {
    path: '/sign',
    name: 'Sign',
    meta: '专家签到',
    component: () => import('@/views/sign/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: '登录',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/projectlist',
    name: 'projectList',
    meta: '项目列表',
    component: () => import('@/views/projectList/index.vue'),
  },
  {
    path: '/projectlist/edit',
    name: 'projectEdit',
    meta: '项目修改',
    component: () => import('@/views/projectList/edit.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

import { setDocumentTitle } from '../utils/document-title-util'
import { getToken } from '../utils/token-util';

router.beforeEach((to, from, next) => {
  setDocumentTitle(to.meta);

  if (to.path === "/login") return next();

  const path = ['/sign'];

  const token = getToken();

  if (!path.includes(to.path)) {
    if (!token) return next('/login');
  }
  next();
});

export default router
